import React from 'react';
import { CyberShieldIcon, NeuralIcon, BlueprintIcon } from '../components/IndustryIcons';
import { FocalQuote, Panel, SectionFrame } from '../components/SectionFrame';
const pillars = [{
  Icon: CyberShieldIcon,
  title: 'Governance & Cyber Risk',
  lead: 'Director-level visibility into the risks that actually threaten a regulated utility.',
  points: ['18+ annual Board and Executive Committee presentations on enterprise risk, AI governance, cybersecurity, and capital investment.', 'NERC CIP readiness maintained across both IT and operational technology environments.', 'First SOX 404 compliance program in nine years, built and stood up from the ground up.', 'Enterprise architecture compliance enforced to reduce regulatory and operational exposure.']
}, {
  Icon: NeuralIcon,
  title: 'AI & Innovation Governance',
  lead: 'A Responsible AI framework that lets the business move fast without losing control of risk.',
  points: ['Architected the enterprise Responsible AI framework and enterprise AI policy.', 'Risk controls calibrated for rapid business adoption rather than blanket prohibition.', 'Cyber and AI risk translated into decisions a board can act on, not technical briefings.', 'Standing counsel to the CEO and CFO on where technology risk touches the balance sheet.']
}, {
  Icon: BlueprintIcon,
  title: 'Capital Stewardship',
  lead: 'Allocation discipline across an asset base that outlives every technology cycle.',
  points: ['$160M annual technology investment portfolio owned end to end.', '$100M in capital allocations directed across regulated infrastructure programs.', 'Technology strategy underwriting $10B+ in regulated utility assets.', 'Investment cases built for rate-regulated review and executive approval.']
}];
export function Governance() {
  return <SectionFrame index="02" eyebrow="Oversight Posture" headline="Board Governance, Cyber Oversight & Capital Allocation" subheadline="The three pillars of oversight David brings into a boardroom: risk that is named and measured, AI adopted under explicit controls, and capital allocated against a regulated asset base." data-id="element-180" data-mp="30iy56cmllax">
      <div className="grid gap-6 lg:grid-cols-3" data-id="element-181" data-mp="244l6kv90epkv">
        {pillars.map(({
        Icon,
        title,
        lead,
        points
      }) => <Panel key={title} className="flex h-full flex-col p-7" data-id="element-182" data-mp="1ge91ds55f6xz">
            <Icon className="h-9 w-9 text-copper" data-id="element-183" data-mp="1gcecy3uo4wp5" />
            <h2 className="display mt-5 text-2xl font-black leading-tight text-steel-dark" data-id="element-184" data-mp="1ce703k3bsfj8">{title}</h2>
            <p className="mt-3 text-[15px] font-medium leading-relaxed text-hydro" data-id="element-185" data-mp="1q5c22su61jwq">{lead}</p>
            <ul className="mt-5 space-y-3 border-t border-panel-deep pt-5 text-[15px] leading-relaxed text-steel-dark/85" data-id="element-186" data-mp="1lcslro43gao8">
              {points.map(p => <li key={p} className="flex gap-3" data-id="element-187" data-mp="sp6cbz86qbtg">
                  <span aria-hidden="true" className="mt-[0.55rem] h-1.5 w-1.5 shrink-0 bg-copper" data-id="element-188" data-mp="son1t3kv6ppg" />
                  {p}
                </li>)}
            </ul>
          </Panel>)}
      </div>

      <FocalQuote data-id="element-189" data-mp="394jeo9b65af3">
        True governance provides the guardrails that allow complex enterprises to move fast without losing control of
        risk.
      </FocalQuote>
    </SectionFrame>;
}